import { ReactElement } from 'react'
import { List, ListItem, ListItemText, Typography } from '@mui/material'
import { AlertDialog } from '@ui/feedback'

interface Props {
  onConfirm: () => Promise<void> | void
  children: ReactElement
}

const WallAlignmentConfirmDialog = ({ onConfirm, children }: Props): ReactElement => (
  <AlertDialog
    title="Wände an SW zuschneiden?"
    text={
      <>
        <Typography variant="body1" gutterBottom>
          Folgende Einstellungen gehen verloren:
        </Typography>
        <List dense disablePadding>
          <ListItem sx={{ py: 0 }}>
            <ListItemText primary="vertikale Verbindungen" />
          </ListItem>
          <ListItem sx={{ py: 0 }}>
            <ListItemText primary="Zugverbindungen" />
          </ListItem>
          <ListItem sx={{ py: 0 }}>
            <ListItemText primary="hinzugefügte Lasten" />
          </ListItem>
          <ListItem sx={{ py: 0 }}>
            <ListItemText primary="Bauteillabels werden geändert" />
          </ListItem>
          <ListItem sx={{ py: 0 }}>
            <ListItemText primary="Ergebnisse werden zurückgesetzt" />
          </ListItem>
        </List>
      </>
    }
    confirmLabel="zuschneiden"
    onConfirm={onConfirm}
  >
    {children}
  </AlertDialog>
)

export default WallAlignmentConfirmDialog
